/**
 * MP CUSTOMIZATION: Age Gate
 * Keep this file isolated from Dawn core JavaScript.
 */

const MP_AGE_GATE_STORAGE_KEY = 'mp-age-gate:verified';

class MpAgeGate extends HTMLElement {
  constructor() {
    super();
    this.onAcceptClick = this.onAcceptClick.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.modal = this.querySelector('.mp-age-gate-modal');
    this.acceptButton = this.querySelector('[data-name="btn-1"]');
    this.dialog = this.querySelector('[role="dialog"]');
    this.imageColumn = this.querySelector('.mp-age-gate__column--image');
    this.imageElement = this.querySelector('.mp-age-gate__image');
    this.layoutElement = this.querySelector('.mp-age-gate__layout');
    this.contentColumn = this.querySelector('.mp-age-gate__column--content');
    this.contentInner = this.querySelector('.mp-age-gate__content-inner');
    this.actions = this.querySelector('.mp-age-gate__actions');
    this.rejectButton = this.querySelector('[data-name="btn-2"]');

    if (!this.modal || !this.acceptButton) return;

    this.acceptButton.addEventListener('click', this.onAcceptClick);

    const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
    const isVerified = localStorage.getItem(MP_AGE_GATE_STORAGE_KEY) === 'true';

    if (!isVerified && !isDesignMode) {
      this.show();
    }
  }

  disconnectedCallback() {
    if (this.acceptButton) {
      this.acceptButton.removeEventListener('click', this.onAcceptClick);
    }
    this.hide();
  }

  onAcceptClick(event) {
    event.preventDefault();
    localStorage.setItem(MP_AGE_GATE_STORAGE_KEY, 'true');
    this.hide();
  }

  show() {
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    if (window.trapFocus && this.dialog) {
      window.trapFocus(this.modal, this.acceptButton);
    }
  }

  hide() {
    if (!this.modal) return;
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    if (window.removeTrapFocus) {
      window.removeTrapFocus();
    }
  }
}

if (!customElements.get('mp-age-gate')) {
  customElements.define('mp-age-gate', MpAgeGate);
}
